module.exports = __webpack_public_path__ + "img/avatar_small.jpg?ca53203e787604bb5eda57bbfe2ab0a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar_small.jpg
// module id = 1360
// module chunks = 1